import { keyBy } from "lodash";

interface ResourceTypes {
  type: string;
  allLink: string;
  image: string;
  name: string;
  description: string;
  displayOn: string[];
}

const ALL_RESOURCE_TYPES: ResourceTypes[] = [
  {
    type: "technical-info",
    allLink: "/resources/technical-info",
    image: "/images/icons/product.svg",
    name: "Product Use & Technical",
    description: "Working properties, application guidance, mixing and usage.",
    displayOn: ["resources", "search"],
  },
  {
    type: "safety-data-sheets",
    allLink: "/resources/safety-data-sheets",
    image: "/images/icons/safety.svg",
    name: "Safety Data",
    description: "Handling and health information related to chemical composition of products.",
    displayOn: ["resources", "search"],
  },
  {
    type: "health-and-safety",
    allLink: "/resources/safety-data-sheets",
    image: "/images/icons/safety.svg",
    name: "Health and Safety",
    description: "Handling and health information related to chemical composition of products.",
    displayOn: [],
  },
  {
    type: "video",
    allLink: "/videos/list",
    image: "/images/icons/video.svg",
    name: "Video",
    description: "Product and application videos",
    displayOn: ["resources", "search"],
  },
  {
    type: "reference-material",
    allLink: "/resources/reference-material",
    image: "/images/icons/reference.svg",
    name: "Reference Materials",
    description: "Color charts, color pigment information tables, drying times, etc.",
    displayOn: ["resources", "search"],
  },
  {
    type: "external-reference",
    allLink: "/resources/external-reference",
    image: "/images/icons/article.svg",
    name: "Article",
    description: "Scholarly information on art materials, conservation and application.",
    displayOn: ["resources", "search"],
  },
  {
    type: "news",
    allLink: "/news",
    image: "/images/icons/news.svg",
    name: "News",
    description: "Company announcements, gallery openings, product updates, releases, and recalls",
    displayOn: ["search"],
  },
  {
    type: "page",
    allLink: "/",
    image: "/images/icons/page.svg",
    name: "Pages",
    description: "Other content or information related to your search",
    displayOn: ["search"],
  },
  {
    type: "product",
    allLink: "/",
    image: "/images/icons/product2.svg",
    name: "Products",
    description: "Overview of product, including description",
    displayOn: ["search"],
  },
  {
    type: "product-group-page",
    allLink: "/",
    image: "/images/icons/product2.svg",
    name: "Products",
    description: "Overview of product, including description",
    displayOn: [],
  },
];

export const DISPLAY_TYPES = {
  SEARCH: "search",
  RESOURCES: "resources",
};

export const iconMapping = keyBy(
  ALL_RESOURCE_TYPES.filter((i) => i.displayOn.includes("resources")),
  "type",
);
export const searchIconMapping = keyBy(
  ALL_RESOURCE_TYPES.filter((i) => i.displayOn.includes("search")),
  "type",
);

export default ALL_RESOURCE_TYPES;
